import { render } from "./OOCAnalysis_ResultsTable.vue?vue&type=template&id=664d2dff&scoped=true&ts=true"
import script from "./OOCAnalysis_ResultsTable.vue?vue&type=script&lang=ts"
export * from "./OOCAnalysis_ResultsTable.vue?vue&type=script&lang=ts"

import "./OOCAnalysis_ResultsTable.vue?vue&type=style&index=0&id=664d2dff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664d2dff"]])

export default __exports__